{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "devices": "Devices",
    "device-list": "Device List",
    "add-device": "Add Device",
    "device-groups": "Device Groups",
    "device-logs": "Device Logs",
    "automation": "Automation",
    "scenes": "Scenes",
    "automations": "Automations",
    "schedules": "Schedules",
    "users": "Users",
    "user-list": "User List",
    "user-roles": "Roles",
    "user-permissions": "Permissions",
    "developer": "Developer",
    "apps-list": "Applications",
    "api-keys": "API Keys",
    "webhooks": "Webhooks",
    "sdk": "SDK",
    "api-logs": "API Logs",
    "messaging": "Messaging Service",
    "cloud": "Cloud",
    "cloud-storage": "Cloud Storage",
    "cloud-functions": "Cloud Functions",
    "data-analysis": "Data Analysis",
    "documentation": "Documentation",
    "api-docs": "API Documentation",
    "integration-guides": "Integration Guides",
    "tutorials": "Tutorials",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Preferences",
    "services": "Services",
    "browse-services": "Browse Services",
    "my-subscriptions": "My Subscriptions",
    "settings": "Settings",
    "account": "Account",
    "security": "Security",
    "notifications": "Notifications",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "projects": "Projects",
    "project": "Project",
    "presence": "Presence Service",
    "streaming": "Streaming Service",
    "video-call": "Video Call",
    "voice-call": "Voice Call",
    "push-notifications": "Push Notifications",
    "iot-core": "IoT Core",
    "nx-messaging": "NX Messaging",
    "nx-presence": "NX Presence",
    "nx-streaming": "NX Streaming",
    "nx-call": "NX Call",
    "nx-push": "NX Push",
    "nx-iot-core": "NX IoT Core",
    "iot-service": "IoT Service"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "appearance": "Appearance",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore",
    "myProfile": "My Profile",
    "security": "Security",
    "changePassword": "Change Password",
    "apiKeys": "API Keys",
    "myDevices": "My Devices",
    "myAutomations": "My Automations",
    "services": "Services",
    "documentation": "Documentation",
    "support": "Support",
    "management": "Management",
    "help": "Help"
  },
  "users": {
    "title": "Client Users",
    "subtitle": "Manage client access and permissions",
    "addUser": "Add User",
    "moreFilters": "More Filters",
    "searchPlaceholder": "Search users...",
    "filterStatus": "Filter by status",
    "noUsersFound": "No users found",
    "noUsersHint": "Try refreshing or check your API connection",
    "addNewUser": "Add New Client User",
    "editUser": "Edit User",
    "firstName": "First Name",
    "lastName": "Last Name",
    "username": "Username",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "phoneNumber": "Phone Number",
    "bio": "Bio",
    "profilePicture": "Profile Picture",
    "usernameSecurityNote": "Username cannot be changed for security reasons",
    "cancel": "Cancel",
    "createUser": "Create User",
    "updateUser": "Update User",
    "deleteUser": "Delete User",
    "userDetails": "User Details",
    "close": "Close",
    "editUserFromView": "Edit User",
    "noUserDetails": "No user details available",
    "personalInformation": "Personal Information",
    "contact": "Contact",
    "accountDetails": "Account Details",
    "userId": "User ID",
    "createdDate": "Created Date",
    "clientName": "Client Name",
    "phoneVerified": "Phone Verified",
    "verified": "Verified",
    "notVerified": "Not Verified",
    "active": "Active",
    "inactive": "Inactive"
  },
  "apps": {
    "title": "Apps",
    "subtitle": "Manage your NexaConn applications and API credentials",
    "newApplication": "New Application",
    "totalApps": "Total Apps",
    "active": "Active",
    "appsWithKeys": "With API Keys",
    "inDevelopment": "In Development",
    "loadingApplications": "Loading applications…",
    "noApplicationsYet": "No Applications Yet",
    "noApplicationsDescription": "Create your first application to get API credentials and connect to the NexaConn platform.",
    "createApplication": "Create Application",
    "searchPlaceholder": "Search applications…",
    "details": "Details",
    "editApp": "Edit App",
    "close": "Close",
    "newApplicationModal": "New Application",
    "connectToPlatform": "Connect to the NexaConn platform",
    "applicationName": "Application Name",
    "applicationNamePlaceholder": "e.g. Nexa Transport",
    "description": "Description",
    "descriptionPlaceholder": "Describe the purpose of this application",
    "cancel": "Cancel",
    "createApplicationButton": "Create Application",
    "applicationInfo": "Application Info",
    "appId": "App ID",
    "type": "Type",
    "created": "Created",
    "updated": "Updated",
    "client": "Client",
    "username": "Username",
    "email": "Email",
    "apiKey": "API Key",
    "secretKey": "Secret Key",
    "keyInfo": "Key Info",
    "valid": "Valid",
    "expired": "Expired",
    "keyExpiry": "Key Expiry",
    "keyCreated": "Key Created",
    "noApiKey": "No API key available",
    "noSecretKey": "No secret key available"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  }
}
